import { io } from "socket.io-client";
import { BACKEND_URL } from "../Helpers/constant";

const SOCKET_URL = BACKEND_URL;
export const socket = io(SOCKET_URL, {
  transports: ["websocket"],
});

export default socket;
